import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
	constructor(
		private router: Router,
		private authService: AuthService
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		const requiredPermissions: string[] = route.data['permissions'] || [];

		for (const requiredPermission of requiredPermissions) {
			if (this.authService.hasPermission(requiredPermission)) {
				return true; // User has permission, allow access
			}
		}

		// If no match was found, redirect and return false
		this.router.navigate(['/home']);
		return false;
	}
}
